import { gql } from '@apollo/client';

export const GET_STARTER_PACKS = gql`
  query GetStarterPacks {
    starterPacks {
      id
      title
      subtitle
      hskLevel
      wordCount
      proOnly
      description
    }
  }
`;

export const INSTALL_STARTER_PACK = gql`
  mutation InstallStarterPack($packId: ID!) {
    installStarterPack(packId: $packId) {
      id
      hanzi
      pinyin
      hskLevel
      difficulty
    }
  }
`;

// Persist the "Skip for now" choice so onboarding doesn't reappear on next sign-in.
export const MARK_ONBOARDED = gql`
  mutation MarkOnboarded {
    markOnboarded
  }
`;
